module.exports = __webpack_public_path__ + "img/eis.1508a36e.png";